import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './SharingNewMount.types';

export const renderSharingNewMount = (data: IProps) => openPopupHelper({ popupName: popupNames.MOUNT_DIALOG, data });
